
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0vh1CtmMV9vdm9kQj5FJa4PzZsl3KCt5hV6PT_vFkFoMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexwwI0oHyoS4k8jr16IkUubF9OUBPfQnQxgWsIoAYk1VgMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchj_45rlRjx32m8Jdri2q3WGBEcwcFdcdbZGgyqLi8CYUb4Meta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexEgAz0QQqwEEA1f6DGB2qThsFhr3HBBSS0xIw1mvgcuEMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93GbqySOgaHx3_457dr3LTDNNToSP6elKxLvQ7PXuTWb1LAMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexjNs_O025rekuL_45RS_459BEcLjDfmhwL_dIB0X4pcDruyEMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ox3uJTOfzxnU6O9DNNKVnG02VUmgd0w_MxYiwlYlVH0Meta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexee78cYUGbZR_sOlyJKGXdWOM_45YoFGkXv7KqF_c3O1YoMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Q0GNWCIR23ODgav9NoprKy9AS5ljQ5IHM_45JcC6UKLDUMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexWfn3IHjymxOVGuMCMGExI_QLMr165310GwAJ2x8_45TWoMeta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvBe7t_XrSWcahVk1Ldl63WOaN1PIGPYfruuKKrDk6l0Meta } from "/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexjNs_O025rekuL_45RS_459BEcLjDfmhwL_dIB0X4pcDruyEMeta || {},
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexee78cYUGbZR_sOlyJKGXdWOM_45YoFGkXv7KqF_c3O1YoMeta || {},
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexWfn3IHjymxOVGuMCMGExI_QLMr165310GwAJ2x8_45TWoMeta || {},
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvBe7t_XrSWcahVk1Ldl63WOaN1PIGPYfruuKKrDk6l0Meta || {},
    component: () => import("/codebuild/output/src4044068279/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]